<ng-container *ngIf="vo$ | async; let vo">
	<ng-container *ngFor="let entry of vo.structure">
		<ng-container [ngTemplateOutlet]="structureEntry"
									[ngTemplateOutletContext]="{$implicit: entry, level: 0, parentIgnoredSubtree: vo.editMap.get(entry.id)?.conf.shouldIgnoreSubtree}">
		</ng-container>
	</ng-container>

	<ng-template #structureEntry let-entry let-level="level" let-parentIgnoredSubtree="parentIgnoredSubtree">
        <!--  Root structure display  -->
		<div *ngIf="entry.schemaElemType === DataStruct.Root" class="app-depot-structure__root">
			<div class="app-depot-structure__root-display">
				<ng-container [ngTemplateOutlet]="structType"
											[ngTemplateOutletContext]="{$implicit: entry}"></ng-container>
			</div>
		</div>

		<!--  List/Struct/Leaf display  -->
		<div *ngIf="entry.schemaElemType !== DataStruct.Root" class="app-depot-structure__leaf">
			<mat-checkbox id="schema-{{ entry.id }}-checkbox"
										*ngIf="!vo.editMap.get(entry.id)?.isEditActive"
										[disabled]="parentIgnoredSubtree"
										[checked]="vo.editMap.get(entry.id)?.conf!.isSelected"
										(change)="updateSelection($event, entry.id)">
				<div class="app-depot-structure__leaf-display">
					<ng-container [ngTemplateOutlet]="structType"
                                  [ngTemplateOutletContext]="{$implicit: entry}"></ng-container>

					<span appHighlight (click)="disableDeselection($event)" (dblclick)="toggleEditMode($event, entry.id)"
								class="app-depot-structure__entry"
                          [class.app-depot-structure__leaf-display--is-selected]="vo.editMap.get(entry.id)?.conf!.isSelected"
                          [text]="vo.editMap.get(entry.id)?.conf!.currentLabel ?? ''" [searchTerm]="vo.searchTerm"></span>


					<!--      Validation Errors              -->
					<ng-container>
							<div *ngIf="vo.editMap.get(entry.id)?.conf.isSelected && vo.editMap.get(entry.id)?.conf.currentLabel === ''"
									 class="duplicate" (click)="disableDeselection($event)">
									<mat-icon>report</mat-icon>
									<span i18n="@@depot.emptyLabel">Empty Label</span>
							</div>

							<div *ngIf="vo.foundDuplicates.has(entry.id)" class="duplicate" (click)="disableDeselection($event)">
									<mat-icon>report</mat-icon>
									<span i18n="@@depot.duplicateLabel">duplicate-found</span>
							</div>
					</ng-container>

					<!--   Edit mode on entry       -->
					<div *ngIf="vo.editMap.get(entry.id)?.conf!.originalLabel !== vo.editMap.get(entry.id)?.conf!.currentLabel"
                         (click)="disableDeselection($event)" (dblclick)="toggleEditMode($event, entry.id)">
						<span>(</span>
						<span *ngIf="vo.editMap.get(entry.id)?.conf!.originalLabel !== ''" appHighlight
									[text]="vo.editMap.get(entry.id)?.conf!.originalLabel ?? ''" [searchTerm]="vo.searchTerm"
									class="app-depot-structure__leaf--original"></span>
						<span *ngIf="vo.editMap.get(entry.id)?.conf!.originalLabel === ''" appHighlight [text]="EMPTY_LABEL_PLACEHOLDER"  [searchTerm]="vo.searchTerm"
									class="app-depot-structure__leaf--original app-depot-structure__leaf--original--empty"></span>
						<span>)</span>
					</div>
				</div>
			</mat-checkbox>

			<!--  ignore subtree   -->
			<ng-container *ngIf="!parentIgnoredSubtree">
				<!-- Toggle serialization to string-->
				<ng-container *ngIf="!vo.editMap.get(entry.id)?.isEditActive">
					<!--    Struct    -->
					<!--    Always on and disabled    -->
					<ng-container *ngIf="entry.schemaElemType === DataStruct.Struct">
						<mat-slide-toggle [ngModel]="vo.editMap.get(entry.id)?.conf.isSelected" [disabled]="true"
															class="" matTooltip="serialize" i18n-matTooltip="@@depot.entry.array.serialize">
						</mat-slide-toggle>
					</ng-container>

					<!--    Array    -->
					<!--    Always on and disabled if child element is not a leaf   -->
					<ng-container
						*ngIf="entry.schemaElemType === DataStruct.Array && vo.editMap.get(entry.id)?.conf.children[0].schemaElemType !== 'LEAF'">
						<mat-slide-toggle [ngModel]="vo.editMap.get(entry.id)?.conf.isSelected"
															[disabled]="true"
															class="" matTooltip="serialize" i18n-matTooltip="@@depot.entry.array.serialize">
						</mat-slide-toggle>
					</ng-container>

					<!--    Enabled if child element a leaf   -->
<!--					Not Available for now -->
<!--					<ng-container-->
<!--						*ngIf="entry.schemaElemType === DataStruct.Array && vo.editMap.get(entry.id)?.conf.children[0].schemaElemType === 'LEAF'">-->
<!--						<mat-slide-toggle [ngModel]="vo.editMap.get(entry.id)?.conf.isSerialized"-->
<!--															[disabled]="!vo.editMap.get(entry.id)?.conf.isSelected"-->
<!--															(ngModelChange)="updateSerialization($event, entry.id)"-->
<!--															class="" matTooltip="serialize" i18n-matTooltip="@@depot.entry.array.serialize">-->
<!--						</mat-slide-toggle>-->
<!--					</ng-container>-->

					<!--    Leaf   -->
					<!--    Enable if datatype is not string   -->
<!--					<ng-container *ngIf="entry.schemaElemType === DataStruct.Leaf && entry.dataType !== ColumnType.Str">-->
<!--						<mat-slide-toggle [ngModel]="vo.editMap.get(entry.id)?.conf.isSerialized"-->
<!--															[disabled]="!vo.editMap.get(entry.id)?.conf.isSelected"-->
<!--															(ngModelChange)="updateSerialization($event, entry.id)"-->
<!--															class="" matTooltip="serialize" i18n-matTooltip="@@depot.entry.array.serialize">-->
<!--						</mat-slide-toggle>-->
<!--					</ng-container>-->
				</ng-container>

				<app-button *ngIf="!vo.editMap.get(entry.id)?.isEditActive && vo.editMap.get(entry.id)?.conf.shouldIgnoreSubtree &&
                        (entry.schemaElemType === DataStruct.Struct && vo.editMap.get(entry.id)?.conf.children[0].schemaElemType !== 'LEAF' ||
                        entry.schemaElemType === DataStruct.Array && vo.editMap.get(entry.id)?.conf.children[0].schemaElemType !== 'LEAF' ||
                        entry.schemaElemType === DataStruct.Leaf && entry.dataType !== ColumnType.Str)"
										[leftIcon]="DcIcons.KeepOff" class="app-depot-structure__leaf--action__visible"
										(click)="ignoreSubstructure($event, entry.id)" matTooltip="entry-pinned-as-block"
										i18n-matTooltip="@@depot.entry.entry-pinned-as-block"></app-button>
				<app-button *ngIf="!vo.editMap.get(entry.id)?.isEditActive && !vo.editMap.get(entry.id)?.conf.shouldIgnoreSubtree &&
                        (entry.schemaElemType === DataStruct.Struct && vo.editMap.get(entry.id)?.conf.children[0].schemaElemType !== 'LEAF' ||
                        entry.schemaElemType === DataStruct.Array && vo.editMap.get(entry.id)?.conf.children[0].schemaElemType !== 'LEAF' ||
												entry.schemaElemType === DataStruct.Leaf && entry.dataType !== ColumnType.Str)"
										[leftIcon]="DcIcons.KeepOn" class="app-depot-structure__leaf--action__visible"
										(click)="ignoreSubstructure($event, entry.id)" matTooltip="entry-pinned-as-block"
										i18n-matTooltip="@@depot.entry.entry-pinned-as-block"></app-button>

				<!--  reset label icon   -->
				<app-button
					*ngIf="!vo.editMap.get(entry.id)?.isEditActive && vo.editMap.get(entry.id)?.conf!.originalLabel !== vo.editMap.get(entry.id)?.conf!.currentLabel"
					[leftIcon]="DcIcons.ResetText" class="app-depot-structure__leaf--action__hidden"
					(click)="revert($event, entry.id)" matTooltip="reset-label"
					i18n-matTooltip="@@depot.entry.label.reset"></app-button>

				<!--  Auto fix duplicate label icon   -->
				<app-button *ngIf="!vo.editMap.get(entry.id)?.isEditActive"
										[leftIcon]="DcIcons.FixWizard" class="app-depot-structure__leaf--action__hidden"
										(click)="autoFixDuplicateLabel($event, entry.id)" matTooltip="auto-rename"
										i18n-matTooltip="@@depot.entry.array.auto.renaming"></app-button>

				<!--  Edit trigger icon   -->
				<app-button *ngIf="!vo.editMap.get(entry.id)?.isEditActive"
										[leftIcon]="CoreIcons.Edit" class="app-depot-structure__leaf--action__hidden"
										(click)="toggleEditMode($event, entry.id)" matTooltip="edit"
										i18n-matTooltip="@@depot.entry.array.edit"></app-button>

				<!--  Edit mode    -->
				<div *ngIf="vo.editMap.get(entry.id)?.isEditActive" class="app-depot-structure__leaf-edit-mode">
					<div class="md-input">
						<input type="text" [id]="entry.id" #inputLabel="ngModel"
									 [ngModel]="vo.editMap.get(entry.id)?.conf!.currentLabel"
									 (keydown.enter)="updateCurrentLabel($event, entry.id, inputLabel.value)"
									 (keydown.escape)="cancelUpdate($event, entry.id)" maxlength="200">
						<!--          <label for="name">label</label>-->
					</div>
					<div class="app-depot-structure__leaf-edit-mode-actions">
						<app-button [leftIcon]="CoreIcons.Check"
												(click)="updateCurrentLabel($event, entry.id, inputLabel.value)"></app-button>
						<app-button [leftIcon]="CoreIcons.Close"
												(click)="cancelUpdate($event, entry.id)"></app-button>
					</div>
				</div>
			</ng-container>
		</div>

		<!--  Recursive display for Struct (Maps/Object) types  -->
		<div *ngIf="entry.children.length !== 0 && !vo.editMap.get(entry.id)?.isFolded" class="indent">
			<ng-container *ngFor="let child of entry.children"
										[ngTemplateOutlet]="structureEntry"
										[ngTemplateOutletContext]="{$implicit: child, level: level + 1, parentIgnoredSubtree: vo.editMap.get(entry.id)?.conf.shouldIgnoreSubtree}">
			</ng-container>
		</div>
	</ng-template>

	<ng-template #structType let-entry>
		<ng-container *ngIf="entry.schemaElemType === DataStruct.Root">
			<mat-icon>start</mat-icon>
			<span i18n="@@depot.child.count.label">Child count:</span>
			  <span>{{entry.children.length}}</span>
		</ng-container>

		<!-- Array entry   -->
		<ng-container *ngIf="entry.schemaElemType === DataStruct.Array">
			<mat-icon [ngClass]="{'closed-struct': vo.editMap.get(entry.id)?.isFolded}"
								(click)="fold($event, entry.id)">data_array</mat-icon>
		</ng-container>

		<!-- Structure entry   -->
		<ng-container *ngIf="entry.schemaElemType === DataStruct.Struct">
			<mat-icon [ngClass]="{'closed-struct': vo.editMap.get(entry.id)?.isFolded}"
								(click)="fold($event, entry.id)">data_object</mat-icon>
		</ng-container>

		<!-- Leaf entry   -->
		<ng-container *ngIf="entry.schemaElemType === DataStruct.Leaf">
			<ng-container *ngIf="!entry.convertTo || entry.convertTo === entry.dataType">
				<app-column-type [type]="entry.dataType" [tooltipDisabled]="true"
													(click)="fold($event, entry.id)"></app-column-type>
			</ng-container>
			<ng-container *ngIf="entry.convertTo && entry.convertTo !== entry.dataType">
				<app-column-type [type]="entry.dataType" [tooltipDisabled]="true"
												 (click)="fold($event, entry.id)"></app-column-type>
				<mat-icon>arrow_forward</mat-icon>
				<app-column-type [type]="entry.convertTo" [tooltipDisabled]="true"
													(click)="fold($event, entry.id)"></app-column-type>
			</ng-container>
		</ng-container>
	</ng-template>
</ng-container>
